import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  FlatList,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { CommonButton } from "../../../common/CommonButton";
import { AppScreens } from "../../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppImages } from "../../../utility/AppImages";
import { ScrollView } from "react-native-gesture-handler";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { enumAddEditPublicPrivateScreen } from "../Event/CreatePrivateEventScreen";
import { ShowLoader } from "../../../common/ShowLoader";
import { getHelpTicketsAPI } from "../../../utility/services/getHelpTickets";
import PaginationComponent from "../../../utility/pagination/Pagination";
import { toast } from "react-toastify";
import Header from "./Common/Header";

export default function ContactUsCenter() {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [arrOnGoingDispute, setArrOnGoingDispute] = useState([]);
  const [pageLastEvaluatedKey, setPageLastEvaluatedKey] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalPagesCount, setTotalPagesCount] = useState(1);

  useEffect(() => {
    const fetchTickets = async () => {
      setShowLoader(true);
      try {
        const { tickets, lastEvaluatedKey, count } = await getHelpTicketsAPI(
          currentPage === 1 ? null : pageLastEvaluatedKey,
          Number(pageLimit)
        );
        const totalPages = Math.ceil(count / pageLimit);
        setTotalPagesCount(totalPages);
        setPageLastEvaluatedKey(lastEvaluatedKey);
        setArrOnGoingDispute(tickets);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setShowLoader(false);
      }
    };

    fetchTickets();
  }, [currentPage, pageLimit]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleLimitChange = (limit) => {
    setPageLimit(limit);
    setCurrentPage(1);
  };

  const navigateToDetail = (ticketData) => {
    navigateToScreen(navigation, AppScreens.CreateTicketEventScreen, {
        checkScreen: enumAddEditPublicPrivateScreen.Edit,
        ticketData: ticketData,
      });
  };
  const renderDisputeCenterItem = ({ item, index }) => (
    <View
      key={index}
      style={{
        height: 32,
        flexDirection: "row",
        paddingTop: 10,
        gap: 10,
        marginTop: 10,
        flex: 1,
      }}
    >
      <View style={styles.itemWidth}>
        <Text
          numberOfLines={1}
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            { color: "white", paddingVertical: 12 },
          ]}
        >
          {item.TicketID}
        </Text>
        <View
          style={{
            height: 1,
            backgroundColor: AppColors.grayColor_505050,
          }}
        />
      </View>
      <View style={styles.itemWidth}>
        <Text
          numberOfLines={1}
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            {
              color: "white",
              paddingVertical: 12,
            },
          ]}
        >
          {item.ticketName}
        </Text>
        <View
          style={{
            height: 1,
            backgroundColor: AppColors.grayColor_505050,
          }}
        />
      </View>

      <View style={styles.itemWidth}>
        <Text
          numberOfLines={1}
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            { color: "white", paddingVertical: 12 },
          ]}
        >
          {item.description}
        </Text>
        <View
          style={{
            height: 1,
            backgroundColor: AppColors.grayColor_505050,
          }}
        />
      </View>
      <View style={[{ paddingTop: 5 }, styles.itemWidth]}>
        <Text
          numberOfLines={1}
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            {
              color: "white",
              paddingVertical: 5,
              paddingHorizontal: 18,
              marginBottom: 9,
              backgroundColor:
                item.status === "Completed"
                  ? AppColors.appGreenColor_51AF07
                  : AppColors.grayColor_565656,
              borderRadius: 8,
              alignSelf: "center",
            },
          ]}
        >
          {item.status}
        </Text>
        <View
          style={{
            height: 1,
            backgroundColor: AppColors.grayColor_505050,
          }}
        />
      </View>
      <View style={styles.itemWidth}>
        <TouchableOpacity
          onPress={() => navigateToDetail(item)}
          style={{
            flexDirection: "row",
            columnGap: 8,
            alignSelf: "center",
          }}
        >
          <Text>
            <Image
              source={AppImages.icCamera}
              style={{
                height: 20,
                width: 16,
                resizeMode: "contain",
                paddingVertical: 15,
              }}
            />
          </Text>
          <Text
            numberOfLines={1}
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              { color: "white", paddingVertical: 12 },
            ]}
          >
            View
          </Text>
        </TouchableOpacity>
        <View
          style={{
            height: 1,
            backgroundColor: AppColors.grayColor_505050,
          }}
        />
      </View>
    </View>
  );

  const renderEmptyState = () => (
    <View style={styles.emptyStateContainer}>
      <Text style={styles.emptyStateText}>No tickets available</Text>
      <Text style={styles.emptyStateDescription}>
        You currently have 0 tickets created.
      </Text>
    </View>
  );

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: AppColors.black_121212,
      }}
    >
      {/* Mobile Navigation header */}
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {}}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <View style={styles.container}>
        <View style={[{ columnGap: 10, margin: 20 }]}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_32, { color: AppColors.white }]}
            >
              Contact Us Center
            </Text>
            <TouchableOpacity
              style={[
                styles.createButtonStyle,
                { backgroundColor: AppColors.appGreenColor_51AF07 },
              ]}
              onPress={() => {
                navigateToScreen(navigation, AppScreens.CreateTicketEventScreen, {
                    checkScreen: enumAddEditPublicPrivateScreen.Add,
                  });
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: "white", fontSize: 15 },
                ]}
              >
                Create New Ticket
              </Text>
            </TouchableOpacity>
          </View>
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.grayColor_505050,
              marginTop: 15,
            }}
          />
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: AppColors.white, marginTop: 20 },
            ]}
          >
            Ticket and Ticket Status
          </Text>
        </View>

        <ScrollView style={{ maxHeight: "80%" }}>
          <ScrollView
            horizontal
            style={{ flex: 1, flexDirection: "column", marginHorizontal: 20 }}
          >
            <View
              style={{
                flex: 1,
                flexDirection: "column",
                marginHorizontal: 20,
                width: "100%",
              }}
            >
              <View
                style={{
                  height: 32,
                  gap: 10,
                  flexDirection: "row",
                  marginTop: 10,
                }}
              >
                {[
                  "Ticket ID",
                  "Ticket Name",
                  "Description",
                  "Ticket Status",
                  "Actions",
                ].map((item, index) => {
                  return (
                    <View
                      key={index}
                      style={[
                        {
                          padding: 4,
                          justifyContent: "flex-start",
                          flexDirection: "row",
                          gap: 8,
                          paddingVertical: 10,
                          backgroundColor: AppColors.grayColor_565656,
                        },
                        styles.itemWidth,
                      ]}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { color: AppColors.white },
                        ]}
                      >
                        {item}
                      </Text>
                    </View>
                  );
                })}
              </View>
              {arrOnGoingDispute.length === 0
                ? renderEmptyState()
                : arrOnGoingDispute.map((item, index) =>
                    renderDisputeCenterItem({ item, index })
                  )}
            </View>
          </ScrollView>
        </ScrollView>
        <View style={[{ columnGap: 10, margin: 20 }]}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <PaginationComponent
              currentPage={currentPage}
              totalPagesCount={totalPagesCount}
              onPageChange={handlePageChange}
              pageLimit={pageLimit}
              onLimitChange={handleLimitChange}
            />
            <TouchableOpacity
              style={[
                styles.backButtonStyle,
                { backgroundColor: "trasparent" },
              ]}
              onPress={() => {
                navigation.dispatch(StackActions.pop());
              }}
            >
              <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: "white" }]}>
                Back
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>

      {<ShowLoader showIndicater={showLoader} />}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    emptyStateContainer: {
      flex: 1,
      justifyContent: "center",
      marginTop: 100,
      alignItems: "center",
    },
    emptyStateText: {
      color: "white",
      fontSize: 16,
      fontWeight: "bold",
    },
    emptyStateDescription: {
      color: "white",
      fontSize: 14,
      marginVertical: 10,
    },
    backButtonStyle: {
      height: 40,
      paddingHorizontal: 45,
      paddingVertical: 12,
      borderRadius: 10,
      borderColor: AppColors.appViolentColor_6D08C3,
      borderWidth: 1,
    },
    submitButtonStyle: {
      height: 40,
      paddingHorizontal: 45,
      paddingVertical: 12,
      borderRadius: 10,
      borderColor: AppColors.appViolentColor_6D08C3,
      borderWidth: 1,
    },
    createButtonStyle: {
      height: 40,
      paddingHorizontal: 25,
      paddingVertical: 12,
      borderRadius: 10,
      borderColor: AppColors.appViolentColor_6D08C3,
      borderWidth: 1,
    },
    itemWidth: {
      width: "19%",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      backButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      submitButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      backButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      submitButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      itemWidth: {
        width: 220,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      backButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      submitButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      backButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      submitButtonStyle: {
        height: 40,
        paddingHorizontal: 45,
        paddingVertical: 12,
        borderRadius: 10,
        borderColor: AppColors.appViolentColor_6D08C3,
        borderWidth: 1,
      },
      itemWidth: {
        width: 250,
      },
    },
  }
);
